import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { CardComponent } from '@custom-components/general/card';
import { ListRowComponent } from '@custom-components/general/list-row/list-row.component';
import { TagComponent, TagState } from '@custom-components/general/tag/tag.component';

export interface NewAlarmRow {
  id: string;
  deviceId: string;
  deviceLdn: string;
  typeLabel: string;
  priorityLabel: string;
  priorityState: TagState;
  age: string;
}

@Component({
  selector: 'xemex-dashboard-new-alarms-widget',
  imports: [CardComponent, ListRowComponent, TagComponent, MatIconModule, TranslateModule],
  styleUrl: './dashboard-new-alarms-widget.component.scss',
  templateUrl: './dashboard-new-alarms-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardNewAlarmsWidgetComponent {
  alarms = input.required<NewAlarmRow[]>();

  viewAll = output<void>();
  /** Emits the alarm's `deviceId` — the container owns the exact route (device detail vs. a
   * future dedicated alarm view), this widget only knows which alarm was clicked. */
  alarmClick = output<string>();
}
